import { render, staticRenderFns } from "./ArticleBodyMultipageNavigation.vue?vue&type=template&id=da29209c"
import script from "./ArticleBodyMultipageNavigation.vue?vue&type=script&lang=ts"
export * from "./ArticleBodyMultipageNavigation.vue?vue&type=script&lang=ts"
import style0 from "./ArticleBodyMultipageNavigation.vue?vue&type=style&index=0&id=da29209c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports